import { Head as InternalHead } from '@inertiajs/react';

export default function Head({ title, useAppName = true, metaDescription }) {
  const appName = import.meta.env.VITE_APP_NAME || 'App Name'; // Fallback for app name
  const fullTitle = useAppName ? `${title} | ${appName}` : title;

  return (
    <InternalHead>
      <title>{fullTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
    </InternalHead>
  );
}
